import { Container, Row, Col, Nav, Navbar } from 'react-bootstrap';
import '../css/App.css';
import logoUrl from '../assets/img/logoEvo7.svg';
import sloganfUrl from '../assets/img/footer_slogan.svg';
import {
  ABOUT_ROUTE, BRANDS_ROUTE, CATALOG_ROUTE,
  CONTACTS_ROUTE, PAY_AND_SHIP_ROUTE, POLICY_OPD_ROUTE,
  REFUND_ROUTE, SERVICES_ROUTE,  WARRANTY_ROUTE, PROMOTIONS_PAGE
} from "../utils/const";
import PolzovSogl from '../assets/document/polzovatelskoe_soglash/polzovatelskoe_soglash.pdf';
import publicOffert from '../assets/document/publicOffert/publicOffert.pdf';

function Footer() {
  return (
    <div className="bg-dark text-light py-4">
      <Container>
        <Row>
          <Col xs={12} sm={6} md={4} lg={3} className="mb-4 text-center text-md-start">
            <a href="/" aria-label="Интернет-магазин ЭВОСЕМЬ">
              <img src={logoUrl} alt="logo" className="img-fluid mb-3" />
            </a>
            <div className="phone-footer mb-3">
              <a className="d-block text-white fw-bold" href="tel:+79375552585">8 937 555-25-85</a>
              <a className="d-block text-secondary small" href="#">Заказать обратный звонок</a>
            </div>
            <img src={sloganfUrl} alt="В ПОИСКАХ КЛИМАТА" className="img-fluid mb-3" />
            <span className="small text-secondary d-block">
              © 2009-2025 ИП Галич А.С.<br />
              ИНН 344212182709<br />
              Все права защищены.
            </span>
          </Col>

          <Col xs={12} sm={6} md={4} lg={3} className="mb-4">
            <h6 className="text-uppercase text-white mb-3">Информация</h6>
            <Navbar bg="dark" className="pt-0" data-bs-theme="dark">
              <Nav className="flex-column footerlink" as="ul"> 
                <Nav.Link href={ABOUT_ROUTE} className="p-0 mb-1">О компании</Nav.Link>
                <Nav.Link href={PAY_AND_SHIP_ROUTE} className="p-0 mb-1">Оплата и доставка</Nav.Link>
                <Nav.Link href={WARRANTY_ROUTE} className="p-0 mb-1">Гарантия</Nav.Link>
                <Nav.Link href={REFUND_ROUTE} className="p-0 mb-1">Возврат</Nav.Link>
                <Nav.Link href={CONTACTS_ROUTE} className="p-0 mb-1">Контакты</Nav.Link>
                <Nav.Link href={POLICY_OPD_ROUTE} className="p-0 mb-1">Политика обработки персональных данных</Nav.Link>
                <Nav.Link href={PolzovSogl} target="_blank" rel="noopener noreferrer" className="p-0 mb-1">Пользовательское соглашение</Nav.Link>
                <Nav.Link href={publicOffert} target="_blank" rel="noopener noreferrer" className="p-0 mb-1">Публичная оферта</Nav.Link>
              </Nav>
            </Navbar>
          </Col>

          <Col xs={12} sm={6} md={4} lg={3} className="mb-4">
            <h6 className="text-uppercase text-white mb-3">Разделы</h6>
            <Navbar bg="dark" className="pt-0" data-bs-theme="dark">
              <Nav className="flex-column footerlink">
                <Nav.Link href={CATALOG_ROUTE} className="p-0 mb-1">Каталог</Nav.Link>
                <Nav.Link href={PROMOTIONS_PAGE} className="p-0 mb-1">Акции </Nav.Link>
                <Nav.Link href={BRANDS_ROUTE} className="p-0 mb-1">Бренды</Nav.Link>
                <Nav.Link href={SERVICES_ROUTE} className="p-0 mb-1">Услуги</Nav.Link>
              </Nav>
            </Navbar>
          </Col>

          <Col xs={12} sm={6} md={6} lg={3} className="mb-4">
            <h6 className="text-uppercase text-white mb-3">Категории</h6>
            <Navbar bg="dark" className="pt-0" data-bs-theme="dark">
              <Nav className="flex-column footerlink">
                <Nav.Link href="/catalog/wall_split_system" className="p-0 mb-1">Бытовые сплит-системы</Nav.Link>
                <Nav.Link href="/catalog/multi_split" className="p-0 mb-1">Мульти сплит-системы</Nav.Link>
                <Nav.Link href="/catalog/floor_ceiling_split" className="p-0 mb-1">Полупромышленное кондиционирование</Nav.Link>
                <Nav.Link href="/catalog/gas_boilers" className="p-0 mb-1">Газовые котлы</Nav.Link>
                <Nav.Link href="/catalog/thermal_technics" className="p-0 mb-1">Тепловое оборудование</Nav.Link>
                <Nav.Link href="/catalog/storage_water_heaters" className="p-0 mb-1">Водонагреватели</Nav.Link>
                <Nav.Link href="/catalog/home_humidifiers" className="p-0 mb-1">Увлажнители и климатические комплексы</Nav.Link>
              </Nav>
            </Navbar>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Footer;
